import React, { Fragment, useState } from 'react';
import './loggedOut.css';

const ContactUs = () => {
    const [formState, setFormState] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const [failure, setFailure] = useState(false)
    const [success, setSuccess] = useState(false)
    const [inProgress, setInProgress] = useState(false)

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormState((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const body = {
                name: formState.name,
                phone: formState.phone,
                email: formState.email,
                message: formState.message,
            };
            setInProgress(true)
            await fetch("/contactUs", {
                method: "POST",
                headers: { "Content-Type": "application/json", token: localStorage.token },
                body: JSON.stringify(body)
            }).then(function (response) {
                setInProgress(false)
                if (response.status === 404 || response.status === 403 || response.status === 409 || response.status === 500) {
                    setFailure(true)
                    setSuccess(false)
                } else {
                    setSuccess(true)
                    setFailure(false)
                }
            }).catch(function (response) {
                setInProgress(false)
                setFailure(true)
                setSuccess(false)
            })

        } catch (err) {
            console.error("Cannot send 'contact us' message")
            console.error(err.message);
        }
    };

    return (
        <div className="logged-out">
            <Fragment>
                <section className="scene scene--hero py-6">
                    <div className="container">
                        <div className="contact-grid">
                            <div className="contact-visual">
                                <img
                                    src="/marketing_images/contact_us/image.jpg"
                                    alt="Contact us"
                                    className="img-fluid contact-image"
                                />
                                <div className="contact-details">
                                    <div className="contact-pill">
                                        <span className="contact-pill__icon">☎</span>
                                        <span>0411 735 579</span>
                                    </div>
                                    <div className="contact-pill">
                                        <span className="contact-pill__icon">✉</span>
                                        <span>jacob@beyondcommunityaccess.com</span>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-card">
                                <p className="contact-kicker">Get in touch</p>
                                <h1>Contact Us</h1>
                                <p className="lead">
                                    Let us know how we can help. We will follow up as soon as we can.
                                </p>
                                <form className="contact-form" onSubmit={handleSubmit}>
                                    <label className="contact-field">
                                        <span>Full Name</span>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formState.name}
                                            onChange={handleChange}
                                            placeholder="Full Name"
                                            required
                                        />
                                    </label>
                                    <label className="contact-field">
                                        <span>Phone</span>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formState.phone}
                                            onChange={handleChange}
                                            placeholder="Phone"
                                        />
                                    </label>
                                    <label className="contact-field">
                                        <span>Email</span>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formState.email}
                                            onChange={handleChange}
                                            placeholder="Email"
                                            required
                                        />
                                    </label>
                                    <label className="contact-field">
                                        <span>Message</span>
                                        <textarea
                                            name="message"
                                            value={formState.message}
                                            onChange={handleChange}
                                            placeholder="Message"
                                            rows="4"
                                            required
                                        />
                                    </label>
                                    <button disabled={inProgress} className="btn btn-success contact-submit" type="submit">
                                        Send
                                    </button>
                                    <div className="contact-feedback">
                                        {success && <p className="text-success">Your message has been sent. We will reach out soon.</p>}
                                        {failure && <p className="text-danger">There was a problem sending your email. Please try again.</p>}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        </div>
    );
}

export default ContactUs;
